<template>
  <div class="tab-table">
    <simple-table
      category="inspections"
      :columns="columns"
      :loading="loading"
      :error="error"
      :list="list"
      :addButton="false"
      @fetch="handleFetch"
    >
      <template #actions>
        <button @click="downloadExcel">Экспорт в Excel</button>
      </template>
    </simple-table>
  </div>
</template>

<script>
import SimpleTable from '@/components/common/SimpleTable';
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'inspections-table',

  components: {
    SimpleTable,
  },

  data() {
    return {
      columns: [
        { label: 'Заявка отправлена', name: 'created_at', width: '25%' },
        { label: 'VIN', name: 'vin', width: '35%' },
        { label: 'Дилерский центр', name: 'dealer_name', width: '20%' },
        {
          label: 'Желаемая дата и время ТО',
          name: 'maintenance_date',
          width: '20%',
        },
      ],
    };
  },

  computed: {
    ...mapGetters({
      loading: 'inspections/loading',
      error: 'inspections/error',
      list: 'inspections/list',
    }),
  },

  methods: {
    ...mapActions({
      fetch: 'inspections/fetch',
      export: 'inspections/export',
    }),

    handleFetch() {
      this.fetch();
    },

    toast(msg, type) {
      if (type === 'success') {
        this.$snotify.success(msg, null, {
          showProgressBar: false,
        });
      }
      if (type === 'error') {
        this.$snotify.error(msg, null, {
          showProgressBar: false,
        });
      }
    },

    async downloadExcel() {
      const file = await this.export();

      if (file.data) {
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(file.data);
        link.download = 'Report.xlsx';
        link.click();
      } else {
        this.toast('Произошла ошибка при загрузке файла.', 'error');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.tab-table {
  display: flex;
  flex-direction: column;
  flex: 1;
}
</style>
